import script from "./confirm-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-dialog.vue?vue&type=script&setup=true&lang=js"

import "./confirm-dialog.vue?vue&type=style&index=0&id=ac532a70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac532a70"]])

export default __exports__